import { render } from "./FloorPlanUpdateModal.vue?vue&type=template&id=33d046f5"
import script from "./FloorPlanUpdateModal.vue?vue&type=script&lang=js"
export * from "./FloorPlanUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__